import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import { PasswordCell } from "./PasswordCell";
import { getHumanReadableTimePassedSinceThisInstance } from "Utils/Common";

export function Row(props) {
  const { row, index, handleClick, isSelected } = props;
  const [open, setOpen] = React.useState(false);
  const isItemSelected = isSelected(row.name);
  const labelId = `enhanced-table-checkbox-${index}`;
  row.open = () => setOpen(true);
  row.close = () => setOpen(false);

  let contribution = "-";
  if (row.contribution > 0) {
    contribution = `${row.contribution * 9.18}$ [${row.contribution *
      9.18 *
      70} ₹]`;
  }

  const validEmailDatas = {};
  Object.keys(row.emailData).forEach((email) => {
    if (!email || email.trim().length === 0) {
      return;
    } else {
      validEmailDatas[email] = row.emailData[email];
    }
  });

  return (
    <>
      <TableRow
        key={row.name}
        hover
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={row.name}
        selected={isItemSelected}
      >
        <TableCell padding="checkbox">
          <Checkbox
            checked={isItemSelected}
            inputProps={{ "aria-labelledby": labelId }}
            onClick={(event) => {
              handleClick(event, row.name);
            }}
          />
        </TableCell>
        <TableCell component="th" id={labelId} scope="row" padding="none">
          {row.name}
        </TableCell>
        <TableCell align="center">{row.credits}</TableCell>
        <TableCell align="center">
          {new Date(row.createtime).toLocaleString()}
        </TableCell>
        <TableCell align="center">
          {row.accounts === 0 ? "-" : row.accounts}
        </TableCell>
        <TableCell align="center">
          {row.servers === 0 ? "-" : row.servers}
        </TableCell>
        <TableCell align="center">
          {row.uniqueServers === 0 ? "-" : row.uniqueServers}
        </TableCell>
        <TableCell align="center">
          {row.activeAccounts === 0 ? "-" : row.activeAccounts}
        </TableCell>
        <TableCell align="center">
          {row.taskcount === 0 ? "-" : row.taskcount}
        </TableCell>
        <TableCell align="center">{contribution}</TableCell>
        <TableCell align="center">
          {<PasswordCell value={row.password} />}
        </TableCell>
        {true && (
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        )}
      </TableRow>
      {Object.keys(validEmailDatas).length <= 0 && (
        <TableRow key={row.name + "_details"}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <span style={{ color: "red" }}>No Accounts Added</span>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
      {Object.keys(validEmailDatas).length > 0 && (
        <TableRow key={row.name + "_details"}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Email</TableCell>
                      <TableCell>Alias</TableCell>
                      <TableCell>Validity Remaining</TableCell>
                      <TableCell align="right">Servers</TableCell>
                      <TableCell>Threads</TableCell>
                      <TableCell>ThreadDetails</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(validEmailDatas).map((email) => {
                      const emailData = validEmailDatas[email];

                      const {
                        alias,
                        servers,
                        duration,
                        refillstampmillis,
                        contribution,
                        cachedData,
                      } = emailData;

                      const currentMillis = new Date().getTime();
                      const endTime =
                        parseInt(refillstampmillis) + parseInt(duration) * 1000;
                      let active = false;
                      if (endTime > currentMillis) {
                        active = true;
                      }

                      const daysDifference = getHumanReadableTimePassedSinceThisInstance(
                        endTime
                      ).timeString;

                      let durationDisplay = "Inactive: " + daysDifference;
                      const style = {
                        fontSize: "smaller",
                      };
                      if (active) {
                        durationDisplay = daysDifference;
                        style.color = "green";
                      } else {
                        style.color = "red";
                      }
                      return (
                        <TableRow key={email}>
                          <TableCell component="th" scope="row">
                            {email}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {alias}
                          </TableCell>
                          <TableCell>
                            <span style={style}>{durationDisplay}</span>
                          </TableCell>
                          <TableCell align="right">
                            {servers.join(", ")}
                          </TableCell>
                          <TableCell>
                            <span style={style}>
                              {cachedData ? cachedData.threadCount : "-"}
                            </span>
                          </TableCell>
                          <TableCell>
                            <span style={style}>
                              {cachedData
                                ? cachedData.threadData.map((tdata) => {
                                    return (
                                      <li>
                                        {tdata.name + `(${tdata.state})`}
                                        <br />
                                      </li>
                                    );
                                  })
                                : "-"}
                            </span>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
